var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: _vm.xs, md: _vm.md, "no-margin": "" } },
    [
      _c(
        "w-row",
        { attrs: { "no-margin": "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("w-select", {
                attrs: {
                  fancy: "",
                  label: _vm.$ct("which-day"),
                  items: _vm.whichDaySelectItems,
                  value: _vm.whichDay,
                },
                on: {
                  input: function ($event) {
                    return _vm.setWhichDay($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("app-weekday-select", {
                attrs: {
                  fancy: "",
                  label: _vm.$ct("which-weekday"),
                  value: _vm.weekday,
                  "use-go-days": "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setWeekDay($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }